import { IntegrationIconProps } from './types';

const Badoo = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 11.3333C2 8.06636 2 6.43287 2.6358 5.18506C3.19506 4.08744 4.08744 3.19506 5.18506 2.6358C6.43287 2 8.06636 2 11.3333 2H20.6667C23.9336 2 25.5671 2 26.8149 2.6358C27.9126 3.19506 28.8049 4.08744 29.3642 5.18506C30 6.43287 30 8.06636 30 11.3333V20.6667C30 23.9336 30 25.5671 29.3642 26.8149C28.8049 27.9126 27.9126 28.8049 26.8149 29.3642C25.5671 30 23.9336 30 20.6667 30H11.3333C8.06636 30 6.43287 30 5.18506 29.3642C4.08744 28.8049 3.19506 27.9126 2.6358 26.8149C2 25.5671 2 23.9336 2 20.6667V11.3333Z"
      fill="#7845F5"
    />
    <path
      d="M25.9173 14.25C25.9173 20.0833 21.2507 24.75 16.0007 24.75C10.7507 24.75 6.08398 20.0833 6.08398 14.25C6.08398 9.0652 11.8346 6.36888 15.4173 10.5597L15.709 11.3333H16.2923C16.2923 11.3333 16.5612 10.5597 16.584 10.5597C20.1667 6.36888 25.9173 9.0652 25.9173 14.25Z"
      fill="#F79FEE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3542 14.1617C12.3542 16.1752 13.9865 17.8075 16 17.8075C18.0135 17.8075 19.6458 16.1752 19.6458 14.1617H21.6875C21.6875 17.3028 19.1411 19.8492 16 19.8492C12.8589 19.8492 10.3125 17.3028 10.3125 14.1617H12.3542Z"
      fill="#7845F5"
    />
  </svg>
);
export default Badoo;
